import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';

export const FIRST_VIEW_STATUSES = [
  ApplicantStatusesEnum.CANDIDATE_REVIEW,
  ApplicantStatusesEnum.INTERVIEW_PHASE,
];

export const DEFAULT_STATUSES = [ApplicantStatusesEnum.NEW, ApplicantStatusesEnum.CANDIDATE_REVIEW];
